import {Component} from '@angular/core';
import {AuthService, LoginFormType, QUERY_PARAM_LOGIN_FORM_TYPE} from '@aiwyn/auth';
import {ActivatedRoute, Router} from '@angular/router';
import {ROUTE_TOKEN_LOGIN} from '../../../routing-constants';
import {map, withLatestFrom} from 'rxjs/operators';
import {AssetUriService, LaunchDarklyFlag, LaunchDarklyService} from '@aiwyn/config';

@Component({
  selector: 'app-login-passwordless-wait',
  templateUrl: './login-passwordless-wait.component.html',
  styleUrls: ['./login-passwordless-wait.component.scss'],
  standalone: false,
})
export class LoginPasswordlessWaitComponent {
  enableMagicLinkExperience$ = this.launchDarklyService.getFeatureFlag(LaunchDarklyFlag.ENABLE_PASSWORDLESS_LOGIN);

  emailAddress$ = this.activatedRoute.queryParams.pipe(
    withLatestFrom(this.authService.getAuthEmail()),
    map(([params, backupEmailAddress]) => {
      return params.emailAddress || backupEmailAddress;
    }),
  );

  constructor(
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly router: Router,
    public assetUriService: AssetUriService,
  ) { }

  goBack(): void {
    this.router.navigate([ROUTE_TOKEN_LOGIN]);
  }

  switchToUsernamePasswordLoginFlow(): void {
    this.router.navigate(
      [ROUTE_TOKEN_LOGIN],
      { queryParams: { [QUERY_PARAM_LOGIN_FORM_TYPE]: LoginFormType.USERNAME_PASSWORD } }
    );
  }
}
